module.exports = __webpack_public_path__ + "img/denglu.e26b5fc9.png";